import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import NoGapContentpoints from "../../Components/sub-pages/NoGapContent_point";
import { li } from "framer-motion/client";
import { listIcons } from "@iconify/react/dist/iconify.js";
import DynamicFaqs from "../../Components/home/Faqs";

const CorporateGifting = () => {
  const CTAContent = [
    {
      pageName: "Corporate Gifting",
      paragraphitalic: "Build Stronger Business Relationships ",
      paragraphText:
        "Delight clients, partners, and prospects with thoughtfully curated corporate gifts that leave a lasting impression. From premium hampers to personalized gifts, our solutions are designed to resonate with your audience and showcase your brand values. ",
      ContactFormName: "Corporate Gifting",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Meaningful Gifts. Memorable Connections. ",
      parapgraphItalic: "Highlight your company identity",
      sectionparagraphText: (
        <>
          <p>
            At eYantra, we believe gifting is more than a gesture, and it’s a language of appreciation that strengthens business relationships and builds emotional connections. As India’s most trusted name in corporate gifting and custom corporate gifts, we help organizations celebrate people, express gratitude, and bring brands to life through beautifully curated gifting experiences.
          </p>
          <p>
            With over 20 years of experience, we have worked with 3,000+ corporates across industries from IT and BFSI to manufacturing, pharma, and startups. Whether you need onboarding kits for new hires, rewards for employees, or luxury hampers for clients, we combine creativity, customization, and seamless delivery to make every gift count.
          </p>
        </>
      ),
      ImgSrc: "../assests/images/Corporate gifting/Meaningful Gifts. Memorable Connections.jpg",
    },
    {
      index: 1,
      sectionName: "Why Corporate Gifting Matters More Than Ever:",
      parapgraphItalic: "Choose from a diverse range of options.",
      sectionparagraphText: (
        <>
          <p>
            Corporate gifting is no longer an annual ritual; it's a powerful business tool. A thoughtful gift can motivate employees, nurture client relationships, and showcase your brands personality. 
          </p>
          <p>
              In a post-digital world where connections matter more than transactions, companies that gift mindfully stand out. Corporate gifts have evolved from token giveaways to personalized experiences that reflect corporate values, sustainability, inclusivity, and appreciation. 
          </p>
          <p>
              At eYantra, we design gifting programs that align with your brand identity, helping you foster loyalty and engagement all year round. 
          </p>
        </>
      ),
      ImgSrc: "../assests/images/sub-pages/wide-assortment.png",
      // categoryHeadingLeftSide: "Our Categories Include:",
      // CategoriesLeftContent: [
      //   {
      //     CategoryImg: "../assests/images/sub-pages/tech-gadgets.png",
      //     CategoryName: "Tech Gadgets",
      //   },
      //   {
      //     CategoryImg: "../assests/images/sub-pages/lifestyle.png",
      //     CategoryName: "Lifestyle Products",
      //   },
      //   {
      //     CategoryImg: "../assests/images/sub-pages/eco-friendly.png",
      //     CategoryName: "Eco-Friendly Items",
      //   },
      // ],
    },
   
  ];

  const noGapContent = [
    {
      RightImgNogap: "../assests/images/sub-pages/custom-branding.png",
      NogapHeading: "What Makes eYantra India’s Most Trusted Corporate Gifting Partner",
      paragraphItalic:"Thousands of businesses choose eYantra for a reason. Our solutions bring together creative design, technology, and reliable logistics to make gifting easy and impactful.",
      Heading: [
        {
          ListHeading: "End-to-End Service:",
          ListParagraph: "From idea to delivery we handle curation, branding, packaging, and pan-India dispatch.",
        },
        {
          ListHeading: "Pan-India & Global Reach:",
          ListParagraph:
            "Delivering to offices, remote employees, or global partners we manage logistics effortlessly. ",
        },
        {
          ListHeading: "Personalization at Scale:",
          ListParagraph:
            "Custom branding, printing, embroidery, or engraving we tailor gifts for every recipient.",
        },
        {
          ListHeading: "Sustainable Focus:",
          ListParagraph:
            "Our ecoR’us initiative supports biodegradable, upcycled, and zero waste gifting.",
        }
      ],
     
    },

    /**new index */
    {
      RightImgNogap: "../assests/images/sub-pages/IMG-5.png",
      NogapHeading: "How We Create Custom Corporate Gifts That Reflect Your Brand",
      paragraphItalic:"",
      paragraphDetail:(
        <>
          <p>
           Your brand story deserves to be told through every gift you send. Our creative process ensures each product embodies your vision, values, and style.
          </p>
        </>
      ),
    
      NogapSubheading: "Custom Branding Services Include:",
      Categories: [
        {
          ServiceImg: "../assests/images/sub-pages/logo-printing.png",
          ServiceText: "Customization",
        },
        {
          ServiceImg: "../assests/images/sub-pages/engraving.png",
          ServiceText: "Curation",
        },
        {
          ServiceImg: "../assests/images/sub-pages/color-matching.png",
          ServiceText: "Packaging",
        },
      ],
    },
  ];

  const NoGapContentPoints =[
    {
      RightImgNogap: "../assests/images/Corporate gifting/Our Expertise in Corporate Gifting.jpg",
      NogapHeading: "Our Expertise in Corporate Gifting",
      Heading: [
        {
          ListHeading: "Employee Onboarding & Joining Kits",
          ListParagraph: "",
        },
        {
          ListHeading: "Sustainable & Eco-Friendly Corporate Gifts",
          ListParagraph:
            "",
        },
        {
          ListHeading: "Rewards & Recognition Gifts ",
          ListParagraph:
            "",
        },
        {
          ListHeading: "Branded Merchandise for Corporates ",
          ListParagraph:
            "",
        },
        {
          ListHeading: "Festive & Seasonal Gifting ",
          ListParagraph:
            "",
        },
        {
          ListHeading:"Corporate Brand Stores",
          ListParagraph:"",
        }
      ],
     
    },
  ]

  const faqsData = [
  {
    question: "What are the best corporate gifts for employees?",
    answer:
      "Popular corporate gifts for employees include practical yet stylish items such as branded drinkware, notebooks, tech accessories, apparel, and sustainable lifestyle products. These gifts show thoughtfulness while promoting your brand.",
  },
  {
    question: "Why is corporate gifting important in business?",
    answer:
      "Corporate gifting helps organizations express gratitude, build loyalty, and strengthen professional relationships. It’s a tangible reminder of appreciation that boosts morale and brand recall.",
  },
  {
    question: "How can I customize corporate gifts with my logo?",
    answer:
      "At eYantra, we offer complete customization options including logo printing, laser engraving, embroidery, and customized packaging. Each gift can reflect your company’s identity.",
  },
  {
    question: "Can corporate gifts be eco-friendly?",
    answer:
      "Absolutely! Our eco-friendly corporate gifts include reusable drinkware, bamboo kits, seed-paper diaries, and biodegradable packaging—ideal for brands committed to sustainability.",
  },
  {
    question: "What is the process for ordering bulk corporate gifts?",
    answer:
      "Simply share your requirements, quantity, theme, and budget. Our experts will curate, brand, and deliver gifts across India, ensuring smooth end-to-end execution.",
  },
  {
    question: "How do custom corporate gifts help employee engagement?",
    answer:
      "Personalized corporate gifts make employees feel valued and recognized. They build emotional connections, improve satisfaction, and strengthen company culture.",
  },
  {
    question: "What types of gifts are suitable for client appreciation?",
    answer:
      "For clients, premium hampers, artisanal products, and high-end stationery or accessories work best. These gifts reflect professionalism and genuine appreciation.",
  },
  {
    question: "Do you offer Diwali or festive gifting solutions?",
    answer:
      "Yes, we offer festive gifting solutions including premium sweets, dry fruits, eco-friendly candles, and lifestyle accessories—all customizable with your branding.",
  },
  {
    question: "How long does it take to deliver corporate gifts?",
    answer:
      "Delivery timelines depend on order size and customization. Most orders are dispatched within 7–14 days while ensuring quality and timely execution.",
  },
  {
    question: "Can I get a sample before placing a bulk order?",
    answer:
      "Yes, we provide product samples or prototypes before bulk production so you can review design, quality, and branding with confidence.",
  },
  {
    question: "How can eYantra help in creating a year-round gifting strategy?",
    answer:
      "Our corporate gifting experts help design annual gifting programs including onboarding kits, milestone awards, festive gifts, and recognition initiatives—ensuring consistency, cost efficiency, and strong brand impact.",
  },
];


  return (
    <>
      <Helmet>
        <title>eYantra Branded Corporate Gifting</title>
        <meta name="description" content="eYantra offers branded merchandise, bulk gifting, employee gifts, joining kits, and premium company merchandise for all your corporate gifting needs."/>
        <meta name="keywords" content="eyantra, branded merchandise, corporate gifting, joining kits,  corporate gifts, corporate gifts for employees"/>
      </Helmet>
      <div className="p-0 m-2">
      <Ctapage data={CTAContent} />
      
      
        <LeftContentRightImg data={SubpgesLeftContent[0]} />
      <NogapleftImg data={noGapContent[0]} />
      
      <LeftContentRightImg data={SubpgesLeftContent[1]} />
      <NoGapContentpoints data={NoGapContentPoints[0]}/>
      <NogapleftImg data={noGapContent[1]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Make every corporate gift count by aligning it with your brand message and audience preferences.
      </p>

      <Container className="py-5">
              <h2>Frequently Asked Questions</h2>
              <DynamicFaqs faqsDynamicContent={faqsData} />
      </Container>
      

    </>
  );
};

export default CorporateGifting;
